package one.healthium.profile.ui.models

import one.healthium.loco.LString

internal data class CaloriesHistoryUiModel(
    val value: Float,
    val date: LString,
)
